// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */

import * as DecidrNodeId from "../../node-id/src/DecidrNodeId.bs.js";
import * as RescriptRelay from "rescript-relay/src/RescriptRelay.bs.js";

var Types = {};

var variablesConverter = {"__root":{"viewId":{"c":"DecidrNodeId.RelayAppSync"}}};

var variablesConverterMap = {
  "DecidrNodeId.RelayAppSync": DecidrNodeId.RelayAppSync.serialize
};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, variablesConverterMap, undefined);
}

var wrapResponseConverter = {"__root":{"copyView_copiedView_id":{"c":"DecidrNodeId.RelayAppSync"},"copyView_copiedView":{"f":""}}};

var wrapResponseConverterMap = {
  "DecidrNodeId.RelayAppSync": DecidrNodeId.RelayAppSync.serialize
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

var responseConverter = {"__root":{"copyView_copiedView_id":{"c":"DecidrNodeId.RelayAppSync"},"copyView_copiedView":{"f":""}}};

var responseConverterMap = {
  "DecidrNodeId.RelayAppSync": DecidrNodeId.RelayAppSync.parse
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

var Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: variablesConverterMap,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

var Utils = {};

var node = ((function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "name"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "viewId"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "name"
      },
      {
        "kind": "Variable",
        "name": "originalViewId",
        "variableName": "viewId"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v5 = [
  (v2/*: any*/),
  (v4/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Size",
    "kind": "LinkedField",
    "name": "size",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "width",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "height",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "ImageInfo",
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "columnId",
  "storageKey": null
},
v9 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 24
  },
  {
    "kind": "Literal",
    "name": "searchTerm",
    "value": ""
  }
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v12 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "mimetype",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "size",
    "storageKey": null
  },
  (v4/*: any*/)
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SpacesViewMutationsCopyViewMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CopyViewPayload",
        "kind": "LinkedField",
        "name": "copyView",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "View",
            "kind": "LinkedField",
            "name": "copiedView",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "SpacesViewBasicInfo_view"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "SpacesViewData_view"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SpacesViewMutationsCopyViewMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CopyViewPayload",
        "kind": "LinkedField",
        "name": "copyView",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "View",
            "kind": "LinkedField",
            "name": "copiedView",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v6/*: any*/),
              {
                "alias": "viewType",
                "args": null,
                "concreteType": "ViewType",
                "kind": "LinkedField",
                "name": "type",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ImageInfo",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": (v5/*: any*/),
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ColumnView",
                "kind": "LinkedField",
                "name": "columnViews",
                "plural": true,
                "selections": [
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isHidden",
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "order",
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ComponentType",
                    "kind": "LinkedField",
                    "name": "componentType",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ImageInfo",
                        "kind": "LinkedField",
                        "name": "icon",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "coreConfig",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v9/*: any*/),
                "concreteType": "RowConnection",
                "kind": "LinkedField",
                "name": "data",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RowEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Row",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "cells",
                            "plural": true,
                            "selections": [
                              (v10/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "text",
                                    "storageKey": null
                                  },
                                  (v11/*: any*/),
                                  (v8/*: any*/)
                                ],
                                "type": "TextCell",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "number",
                                    "storageKey": null
                                  },
                                  (v11/*: any*/),
                                  (v8/*: any*/)
                                ],
                                "type": "NumberCell",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "percent",
                                    "storageKey": null
                                  },
                                  (v11/*: any*/),
                                  (v8/*: any*/)
                                ],
                                "type": "PercentCell",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "currency",
                                    "storageKey": null
                                  },
                                  (v11/*: any*/),
                                  (v8/*: any*/)
                                ],
                                "type": "CurrencyCell",
                                "abstractKey": null
                              },
                              {
                                "kind": "TypeDiscriminator",
                                "abstractKey": "__isCell"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v11/*: any*/),
                                  (v8/*: any*/),
                                  {
                                    "alias": "switched",
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "switch",
                                    "storageKey": null
                                  }
                                ],
                                "type": "SwitchCell",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v11/*: any*/),
                                  (v8/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "date",
                                    "storageKey": null
                                  }
                                ],
                                "type": "DateCell",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v11/*: any*/),
                                  (v8/*: any*/),
                                  (v6/*: any*/)
                                ],
                                "type": "ImageCell",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v11/*: any*/),
                                  (v8/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "FileInfo",
                                    "kind": "LinkedField",
                                    "name": "audio",
                                    "plural": false,
                                    "selections": (v12/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "type": "AudioCell",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v11/*: any*/),
                                  (v8/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "FileInfo",
                                    "kind": "LinkedField",
                                    "name": "video",
                                    "plural": false,
                                    "selections": (v12/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "type": "VideoCell",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v11/*: any*/),
                                  (v8/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "FileInfo",
                                    "kind": "LinkedField",
                                    "name": "file",
                                    "plural": false,
                                    "selections": (v12/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "type": "FileCell",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v11/*: any*/),
                                  (v8/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "MultiSelectData",
                                    "kind": "LinkedField",
                                    "name": "data",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "View",
                                        "kind": "LinkedField",
                                        "name": "sourceView",
                                        "plural": false,
                                        "selections": [
                                          (v2/*: any*/),
                                          {
                                            "alias": "viewType",
                                            "args": null,
                                            "concreteType": "ViewType",
                                            "kind": "LinkedField",
                                            "name": "type",
                                            "plural": false,
                                            "selections": [
                                              (v7/*: any*/),
                                              (v2/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SelectedRowInfo",
                                        "kind": "LinkedField",
                                        "name": "selectedRows",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Row",
                                            "kind": "LinkedField",
                                            "name": "row",
                                            "plural": false,
                                            "selections": [
                                              (v2/*: any*/),
                                              (v13/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v2/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "MultiSelectCell",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v11/*: any*/),
                                  (v8/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "LookupCellData",
                                    "kind": "LinkedField",
                                    "name": "data",
                                    "plural": false,
                                    "selections": [
                                      (v10/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "LookupCell",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v13/*: any*/),
                          (v10/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "data(first:24,searchTerm:\"\")"
              },
              {
                "alias": null,
                "args": (v9/*: any*/),
                "filters": [
                  "searchTerm",
                  "caller"
                ],
                "handle": "connection",
                "key": "SpacesView_view_data",
                "kind": "LinkedHandle",
                "name": "data"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0aacbbbb9c300b98c2430d03aa58d5fc",
    "id": null,
    "metadata": {},
    "name": "SpacesViewMutationsCopyViewMutation",
    "operationKind": "mutation",
    "text": "mutation SpacesViewMutationsCopyViewMutation(\n  $name: String!\n  $viewId: ID!\n) {\n  copyView(input: {name: $name, originalViewId: $viewId}) {\n    copiedView {\n      id\n      name\n      ...SpacesViewBasicInfo_view\n      ...SpacesViewData_view\n    }\n  }\n}\n\nfragment SpacesAudioCell_audioCell on AudioCell {\n  audio {\n    ...SpacesFileInfo_fileInfo\n  }\n  rowId\n  columnId\n}\n\nfragment SpacesCache_columnView on ColumnView {\n  columnId\n  isHidden\n}\n\nfragment SpacesCache_row on Row {\n  id\n  viewId\n}\n\nfragment SpacesCells_cell on Cell {\n  __isCell: __typename\n  __typename\n  ... on TextCell {\n    rowId\n    columnId\n    ...SpacesTextCell_textCell\n  }\n  ... on NumberCell {\n    rowId\n    columnId\n    ...SpacesNumberCell_numberCell\n  }\n  ... on PercentCell {\n    rowId\n    columnId\n    ...SpacesPercentCell_percentCell\n  }\n  ... on CurrencyCell {\n    rowId\n    columnId\n    ...SpacesCurrencyCell_currencyCell\n  }\n  ... on SwitchCell {\n    rowId\n    columnId\n    ...SpacesSwitchCell_switchCell\n  }\n  ... on DateCell {\n    rowId\n    columnId\n    ...SpacesDateCell_dateCell\n  }\n  ... on ImageCell {\n    rowId\n    columnId\n    ...SpacesImageCell_imageCell\n  }\n  ... on AudioCell {\n    rowId\n    columnId\n    ...SpacesAudioCell_audioCell\n  }\n  ... on VideoCell {\n    rowId\n    columnId\n    ...SpacesVideoCell_videoCell\n  }\n  ... on FileCell {\n    rowId\n    columnId\n    ...SpacesFileCell_fileCell\n  }\n  ... on MultiSelectCell {\n    rowId\n    columnId\n    ...SpacesMultiSelectCellCache_multiSelectCell\n    ...SpacesMultiSelectCellData_multiSelectCell\n  }\n  ... on LookupCell {\n    rowId\n    columnId\n    ...SpacesLookupCellCache_lookupCell\n    ...SpacesLookupCellData_lookupCell\n  }\n}\n\nfragment SpacesCurrencyCell_currencyCell on CurrencyCell {\n  currency\n  rowId\n  columnId\n}\n\nfragment SpacesDateCell_dateCell on DateCell {\n  date\n  rowId\n  columnId\n}\n\nfragment SpacesFileCell_fileCell on FileCell {\n  file {\n    ...SpacesFileInfo_fileInfo\n  }\n  rowId\n  columnId\n}\n\nfragment SpacesFileInfo_fileInfo on FileInfo {\n  mimetype\n  size\n  url\n}\n\nfragment SpacesImageCell_imageCell on ImageCell {\n  image {\n    ...SpacesImageInfo_imageInfo\n    id\n  }\n  rowId\n  columnId\n}\n\nfragment SpacesImageInfo_imageInfo on ImageInfo {\n  id\n  url\n  size {\n    width\n    height\n  }\n}\n\nfragment SpacesLookupCellCache_lookupCell on LookupCell {\n  rowId\n  columnId\n}\n\nfragment SpacesLookupCellData_lookupCell on LookupCell {\n  ...SpacesLookupCellCache_lookupCell\n  data {\n    __typename\n  }\n}\n\nfragment SpacesMultiSelectCellCache_multiSelectCell on MultiSelectCell {\n  rowId\n  columnId\n}\n\nfragment SpacesMultiSelectCellData_multiSelectCell on MultiSelectCell {\n  ...SpacesMultiSelectCellCache_multiSelectCell\n  data {\n    sourceView {\n      id\n      viewType: type {\n        code\n        id\n      }\n    }\n    selectedRows {\n      row {\n        ...SpacesCache_row\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment SpacesNumberCell_numberCell on NumberCell {\n  number\n  rowId\n  columnId\n}\n\nfragment SpacesPercentCell_percentCell on PercentCell {\n  percent\n  rowId\n  columnId\n}\n\nfragment SpacesRowListData_row on Row {\n  ...SpacesCache_row\n  id\n  cells {\n    __typename\n    ...SpacesCells_cell\n  }\n}\n\nfragment SpacesSwitchCell_switchCell on SwitchCell {\n  switched: switch\n  rowId\n  columnId\n}\n\nfragment SpacesTextCell_textCell on TextCell {\n  text\n  rowId\n  columnId\n}\n\nfragment SpacesVideoCell_videoCell on VideoCell {\n  video {\n    ...SpacesFileInfo_fileInfo\n  }\n  rowId\n  columnId\n}\n\nfragment SpacesViewBasicInfo_view on View {\n  id\n  name\n  ...SpacesViewImage_view\n}\n\nfragment SpacesViewData_view on View {\n  id\n  columnViews {\n    ...SpacesCache_columnView\n    id\n    order\n    isHidden\n    name\n    columnId\n    componentType {\n      id\n      code\n      icon {\n        url\n        id\n      }\n    }\n  }\n  viewType: type {\n    id\n    code\n  }\n  coreConfig\n  data(first: 24, searchTerm: \"\") {\n    edges {\n      node {\n        id\n        cells {\n          __typename\n          ... on TextCell {\n            ...SpacesTextCell_textCell\n            columnId\n            text\n          }\n          ... on NumberCell {\n            ...SpacesNumberCell_numberCell\n            columnId\n            number\n          }\n          ... on PercentCell {\n            ...SpacesPercentCell_percentCell\n            columnId\n            percent\n          }\n          ... on CurrencyCell {\n            ...SpacesCurrencyCell_currencyCell\n            columnId\n            currency\n          }\n        }\n        ...SpacesRowListData_row\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment SpacesViewImage_view on View {\n  image {\n    ...SpacesImageInfo_imageInfo\n    id\n  }\n  viewType: type {\n    icon {\n      ...SpacesImageInfo_imageInfo\n      id\n    }\n    id\n  }\n}\n"
  }
};
})());

export {
  Types ,
  Internal ,
  Utils ,
  node ,
}
/* node Not a pure module */
